import Storage from './Storage';

/**
 * Store ClientLanguage
 * 
 */
class ClientLanguage extends Storage {
    storeName = 'client_language_';
    hasOldKey = true;

    /**
     * ClientLanguage constructor
     * 
     * @param {string} id client id
     */
     constructor(id) {
        super();
        this.id = id;
        this.setKey();
    }

}

export default ClientLanguage;